import { useCallback } from 'react';
import { BlockerFunction } from 'react-router-dom';

export const usePurchaseOrderNavigationBlocker = (registerUnsavedChanges: boolean) => {
  const blocker: BlockerFunction = useCallback(
    ({ nextLocation }) => {
      if (registerUnsavedChanges && !nextLocation.pathname.includes('purchaseOrders')) {
        return true;
      }
      return false;
    },
    [registerUnsavedChanges]
  );

  return blocker;
};
